import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { isDesktop } from "isDesktop";
import "./style.less";
// import icons from "src/Common/Assets/Icons/ShopeeLogo/index.js";
import logo from "src/Common/Assets/Icons/ShopeeLogo/shopeePayLogo2022.svg";
import logoMobile from "src/Common/Assets/Icons/ShopeeLogo/shopeePayLogoMobile2022.svg";
import { Body1, Headline } from "src/Common/Theme/Typography";
import {
  introHeaderEng,
  introHeaderMy,
  introHeaderVn,
  introSubtitleEng,
  introSubtitleMy,
  introSubtitleVn,
	introSubtitleVnEng
} from "../../Constants/Constants";

import { REGIONS } from "src/Services/RegionGetter/Constants";

export const HomePageIntroSection = () => {
  // reducer
  const regionLanguage = useSelector((state) => state.RegionLanguageReducer);
  const { region, language } = regionLanguage;

  // state
  const [introHeader, setIntroHeader] = useState("");
  const [introSubtitle, setIntroSubtitle] = useState("");

  // effect
  useEffect(() => {
    switch (true) {
      case language === REGIONS.malaysia:
        setIntroHeader(introHeaderMy);
        setIntroSubtitle(introSubtitleMy);
        break;
      case region === REGIONS.malaysia && language === "en":
        setIntroHeader(introHeaderEng);
        setIntroSubtitle(introSubtitleEng);
        break;
      case region === REGIONS.vietnam && language === "en":
        setIntroHeader(introHeaderEng);
        setIntroSubtitle(introSubtitleVnEng);
        break;
		case region === REGIONS.vietnam && language === "vn":
        setIntroHeader(introHeaderVn);
        setIntroSubtitle(introSubtitleVn);
        break;
      default:
    }
  }, [language, region]);

  return (
    <>
      {/* Desktop */}
      {isDesktop() ? (
        <div className="HomePageIntro" id="aboutUs">
          <div className="HomePageIntro__AboutLogo">
            <img
              src={logo}
              alt="shopeeIcon"
              width="342px"
              height="68px"
            />
          </div>
          <Headline h1 shopee bold className="HomePageIntro__ContentSubtitle">
            {introHeader}
          </Headline>
          <Body1 className="HomePageIntro__AboutText">{introSubtitle}</Body1>
        </div>
      ) : (
        <div className="HomePageIntroMobile" id="aboutUs">
          <div className="HomePageIntroMobile__AboutLogo">
            <img
              src={logoMobile}
              width="243px"
              height="68px"
              alt="shopeeIcon"
            />
          </div>
          <div>
            <Headline
              h1
              shopee
              bold
              className="HomePageIntroMobile__ContentTitle"
            >
              {introHeader}
            </Headline>
          </div>
          <div className="HomePageIntroMobile__ContentInfoMobile">
            {introSubtitle}
          </div>
        </div>
      )}
    </>
  );
};
